import React from 'react'
import { Truck, RefreshCw, Shield, Star, Award } from 'lucide-react'
import type { BrandBenefitType } from '@storefronts/common-types'

export type BenefitIconProps = React.SVGAttributes<SVGSVGElement> & {
    type: BrandBenefitType
}

export const BenefitIcon = React.forwardRef<SVGSVGElement, BenefitIconProps>(
    ({ type, ...rest }, ref) => {
        switch (type) {
            case 'SHIPPING':
                return <Truck ref={ref} {...rest} />
            case 'RETURN':
                return <RefreshCw ref={ref} {...rest} />
            case 'WARRANTY':
                return <Shield ref={ref} {...rest} />
            case 'GUARANTEE':
                return <Award ref={ref} {...rest} />
            default:
                return <Star ref={ref} {...rest} />
        }
    },
)

BenefitIcon.displayName = 'BenefitIcon'
